import { onMounted, onUnmounted, ref } from 'vue'
import { isInIframe } from '@/utils/utils'
import bus from '@/utils/bus'

export const NOTIFY_KEY = {
  // 隐藏关闭按钮
  HIDE_CLOSE: 'hide_close',
  // 显示关闭按钮
  SHOW_CLOSE: 'show_close',
  // 打开模态框
  OPEN_MODAL: 'openModal',
  // 关闭模态框
  CLOSE_MODAL: 'closeModal',
  // 清除模态框
  CLEAR_MODAL: 'clearModal',
  // 弹出模态框
  POP_MODAL: 'popModal',
  // 设置会话
  SET_SESSION: 'setSession',
  // 跳转到指定URL
  TO_URL: 'to_url',
  // 添加页面
  ADD_PAGE: 'addPage',
  // 返回上一页
  TO_PREVIOUS_PAGE: 'toPreviousPage',
  // 注销监听
  LOGOUT_LISTENING: 'logoutListening',
  // 关闭整个模态框
  ALL_CLOSE_MODAL: 'allCloseModal',
  // 通知微信跳转
  TO_WE_CHAT_URL: 'toWeChatUrl',
  // 通知顶层支付
  TO_PAY: 'toPay',
  // 支付成功
  PAY_SUCCESS: 'paySuccess',
  // 支付失败
  PAY_FAIL: 'payFail',
  // 取消支付
  PAY_CANCEL: 'payCancel',
}

function useIframe() {
  // 获取query中modal的值
  // const modal = ref(new URLSearchParams(window.location.search).get('modal'))
  const isFrame = ref(isInIframe())

  function notifyParent(key, data = null) {
    let postData = {
      key,
      ...data,
    }

    window.parent.postMessage(postData, '*')
  }

  function handleMessage(event) {
    const data = event.data
    switch (data.key) {
      case NOTIFY_KEY.CLOSE_MODAL:
        bus.$emit(data.type, data)
        break
      case NOTIFY_KEY.SET_SESSION:
        setSessionStore(event)
        break
      case NOTIFY_KEY.TO_PREVIOUS_PAGE:
        window.history.back()
        break
      case NOTIFY_KEY.LOGOUT_LISTENING:
        window.removeEventListener('message', handleMessage)
        break
      case NOTIFY_KEY.PAY_SUCCESS:
        bus.$emit('trainPaySuccess', data)
        break
      case NOTIFY_KEY.PAY_FAIL:
        bus.$emit('trainPayFail', data)
        break
      case NOTIFY_KEY.PAY_CANCEL:
        bus.$emit('trainPayCancel', data)
        break
    }
  }

  function setSessionStore({ data, sKey }) {
    sessionStorage.setItem(sKey, data)
  }

  function openModal(type) {
    notifyParent(NOTIFY_KEY.OPEN_MODAL, { type })
  }

  function notifyToUrl(url) {
    notifyParent(NOTIFY_KEY.TO_URL, { url })
  }

  function popModal() {
    notifyParent(NOTIFY_KEY.POP_MODAL)
  }

  function notifyCurrentPage(url) {
    notifyParent(NOTIFY_KEY.ADD_PAGE, { url })
  }

  onMounted(() => {
    console.log('注册事件')
    window.addEventListener('message', handleMessage)
  })

  return {
    isFrame,
    notifyParent,
    openModal,
    popModal,
    notifyToUrl,
    notifyCurrentPage,
  }
}

let install = null
export default () => {
  if (!install) {
    install = ref(useIframe())
  }

  return install.value
}
